import "core-js/modules/es.object.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { outstandingScore, demoTribShadScore, ancientPrisonExoScore, gmGetUserInfo } from '@/api/gmToolNew/gmToolNew';
import { gmToolNew, gmToolNewCom, gmToolNewPage } from "@/mixins/index";
export default {
  mixins: [gmToolNew, gmToolNewCom, gmToolNewPage],
  data: function data() {
    var _this = this;

    var validateuids = function validateuids(rule, value, callback) {
      var regex = /[\u4e00-\u9fa5，]/;

      if (regex.test(value) || !value) {
        if (_this.scoreType != 2) {
          callback(new Error(_this.$t('roleIdIncorrect')));
        } else {
          callback(new Error(_this.$t('playerIdIncorrect')));
        }
      } else {
        callback();
      }
    };

    return {
      dialogShow: false,
      paramsData: {
        uid: '',
        server_id: '',
        score: '',
        damage: ''
      },
      scoreType: '',
      chooseType: '',
      rules: {
        uid: [{
          required: true,
          validator: validateuids,
          trigger: "blur"
        }],
        score: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        damage: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  watch: {
    'paramsData.uid': function paramsDataUid(val) {
      if (val) {
        this.getUserInfo(val);
      }
    }
  },
  methods: {
    open: function open(type) {
      this.scoreType = type;
      this.server_channel = '';
      this.show_test = "";
      this.paramsData = {
        uid: '',
        server_id: '',
        score: '',
        damage: ''
      }, this.dialogShow = true;
      this.paramsData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';
    },
    hiad: function hiad() {
      this.dialogShow = false;
    },
    clearData: function clearData() {
      this.paramsData = {
        uid: '',
        server_id: "",
        score: ''
      };
      this.$refs.ruleForm.clearValidate();
    },
    getUserInfo: function getUserInfo(data) {
      var _this2 = this;

      if (this.scoreType != 2) {
        return;
      }

      if (!data) {
        return;
      }

      console.log("data===", data);

      if (!this.paramsData.server_id) {
        this.$message.error(this.$t('pleaseSelectServer'));
        return;
      }

      var params = {
        env_id: this.paramsData.env_id,
        server_id: this.paramsData.server_id,
        role_id: data,
        game_id: this.rawData.game_id
      };
      gmGetUserInfo(params).then(function (res) {
        if (res.status == 200) {
          _this2.paramsData.score = res.worldBossScore;
          _this2.paramsData.damage = res.worldBossDamage;
        }
      });
    },
    typeChange: function typeChange(type) {
      if (type == 1) {
        this.paramsData.damage = '';
      }

      if (type == 2) {
        this.paramsData.score = '';
      }
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      if (!this.paramsData.server_id) {
        this.$message.error(this.$t('pleaseSelectServer'));
        return;
      }

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          var reqFn = outstandingScore;

          if (_this3.scoreType == 2) {
            reqFn = demoTribShadScore;
          }

          if (_this3.scoreType == 3) {
            reqFn = ancientPrisonExoScore;
          }

          reqFn(_this3.paramsData).then(function (res) {
            if (res.code == 200 || res.status == 200) {
              _this3.$message({
                message: _this3.$t('operationSuccess'),
                type: 'success'
              });

              _this3.dialogShow = false;

              _this3.$emit('change');
            }
          }).finally(function () {
            _this3.issubmit = false;
          });
        }
      });
    }
  }
};